import { DownPaymentType } from '@app/shared/enums/down-payment-type.enum';
export interface ITreatmentApiModel extends ITreatmentIsChecked {
  id: string;
  name: string;
  durationInMinutes: number;
  price: number;
  isPriceInaccurate: boolean;
  isPriceVisibleForOnlineBooking: boolean;
  isDurationVisibleForOnlineBooking: boolean;
  description: string;
  mandatoryDownPayment: DownPaymentType;
  downPaymentRequiredAmount?: number;
}

export interface ITreatmentIsChecked {
  isChecked?: boolean;
}
